// Chequeo de licencia contra Tollkeep. Reutilizable en el login de cualquier app.
// La app solo pregunta "¿esta empresa/tenant tiene licencia al día?"; el cobro vive 100% en Tollkeep.

const TOLLKEEP = {
  url: "https://tollkeep.sw67.ca/v1/license/check",
  platform: "erp-co", // "ERP Colombia Vue 2.0" en Tollkeep
  key: "tk_erp-co_96be5ed37cdd4d45c0e72c494552a9f1",
};

/**
 * Se envía tal cual lo que el usuario escribe en el login: Tollkeep no interpreta
 * el formato (números, letras, lo que sea), solo busca qué licencia cubre ese id.
 * Devuelve el veredicto: { allowed, status, message, payment_url?, covered_count? }.
 */
export async function checkLicense(storeCode) {
  const external_company_id = String(storeCode || "").trim();
  try {
    const res = await fetch(TOLLKEEP.url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Platform-Key": TOLLKEEP.key,
      },
      body: JSON.stringify({ platform: TOLLKEEP.platform, external_company_id }),
    });
    return await res.json();
  } catch (e) {
    // fail-open: si Tollkeep no responde, no bloqueamos el login (continuidad del negocio).
    console.warn("Tollkeep: license check falló, se deja pasar:", e);
    return { allowed: true, _error: String(e) };
  }
}
